import type { HostKind } from "@repo/api";
import { ALLOWED_INTEGRATION_TYPES } from "../constants/integrationTypes";

/**
 * Restricts the Connection Source filter options.
 *
 * Why: the listing page is the only consumer of this helper, and on the legacy
 * host the listing is hard-coded to a single integration type (AWSPlatform).
 * Showing the full API list there would let users pick something the page
 * cannot render.
 */
export function filterIntegrationTypesByHost<T extends { typeName: string }>(
  types: T[],
  host: HostKind,
): T[] {
  if (host !== "legacy") return types;
  const allowed = new Set<string>(ALLOWED_INTEGRATION_TYPES);
  return types.filter((type) => allowed.has(type.typeName));
}
